export const API_METRIC_NAME = {
    "stations" : "stationID",
    "pickRate" : "PICK_RATE",
    "pickTaktTime" : "PICK_TAKT_TIME",
    "podDwellTime" : "POD_DWELL_TIME",
    "podGap" : "POD_GAP_TIME",
    "associate" : "ACTIVE_PICK_ASSOCIATE",
    "stationStatus" : "STATION_STATUS",
    "pickedPackageCount" : "PICK_SUCCESS",
    "packagePileOnRate" : "PILE_ON",
}




// WEBPACK FOOTER //
// ./src/components/workstationMetrics/network/apiMetricNames.js